/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Failed_HeadingInputs */



/**
* | output |
* | --- |
* | "Not added" |
*
* @param {Team_Manager_Import_Failed_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_failed_heading = /** @type {((inputs?: Team_Manager_Import_Failed_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Failed_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non ajoutés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht hinzugefügt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non aggiunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не добавлены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No añadidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未添加")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加されなかったメンバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं जोड़े गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não adicionados")
	return /** @type {LocalizedString} */ ("Not added")
});